import api from 'ApiConfig';

const dashboardService = {
  //DASHBOARDS

  //main dashboard

  fetchMonthwiseAttendance: async (orgId, selectedYear) => {
    return api.post(
      '/dashboard/main-dashboard/all-students-monthwise-attendance',
      {
        userId: orgId,
        selectedYear,
      }
    );
  },

  fetchFeesData: async (orgId, selectedYear) => {
    return api.post('/dashboard/main-dashboard/all-fees-data', {
      orgId,
      selectedYear,
    });
  },

  //attendance dashboard

  fetchClasses: async (userId) => {
    return api.post('/dashboard/main-dashboard/get-classes', { userId });
  },

  fetchClasswiseAttendance: async (orgId, classId, year, month) => {
    return api.post(
      '/dashboard/main-dashboard/get-students-classwise-attendance',
      {
        orgId,
        classId,
        selectedYear: year,
        selectedMonth: month,
      }
    );
  },
  fetchStudentAttendanceDetails: async (
    orgId,
    classId,
    year,
    month,
    studentId
  ) => {
    return api.post(
      '/dashboard/main-dashboard/get-students-attendance-details',
      {
        orgId,
        classId,
        selectedYear: year,
        selectedMonth: month,
        studentId,
      }
    );
  },

  //fee dashboard

  fetchStudentFeeData: async (standard, year, division, orgId) => {
    return api.post('/dashboard/main-dashboard/all-student-fee-data', {
      standard: String(standard),
      year,
      division,
      orgId,
    });
  },

  fetchStudentFeeTransactions: async (studentId, standard) => {
    return api.post('/dashboard/main-dashboard/get-student-fee-transactions', {
      studentId,
      standard: String(standard),
    });
  },

  //student dashboard

  fetchSingleStudentFeeData: async (studentId, classId, year, orgId) => {
    return api.post('/dashboard/main-dashboard/single-student-fee-data', {
      studentId,
      classId,
      orgId,
      selectedYear: year,
    });
  },

  fetchSingleStudentMonthwiseAttendance: async (
    studentId,
    classId,
    year,
    orgId
  ) => {
    return api.post(
      '/dashboard/main-dashboard/single-students-monthwise-attendance',
      {
        studentId,
        classId,
        selectedYear: year,
        orgId,
      }
    );
  },

  //teacher dashboard

  fetchTeachersMonthwiseAttendance: async (orgId, year) => {
    return api.post(
      '/dashboard/main-dashboard/all-teachers-monthwise-attendance-overview',
      {
        orgId,
        selectedYear: year,
      }
    );
  },

  fetchTeachersMonthwiseAttendanceDetails: async (orgId, year, month) => {
    return api.post(
      '/dashboard/main-dashboard/get-teachers-monthwise-attendance',
      {
        orgId,
        selectedYear: year,
        selectedMonth: month,
      }
    );
  },
  fetchSingleTeacherMonthwiseAttendance: async (
    orgId,
    teacherId,
    year,
    month
  ) => {
    return api.post(
      '/dashboard/main-dashboard/get-single-teachers-monthwise-attendance',
      {
        orgId,
        teacherId,
        selectedYear: year,
        selectedMonth: month,
      }
    );
  },

  //LMS

  getFeesDataForChart: async (branchId, startDate, endDate) => {
    return api.post('/dashboard/fee-overview-chart-data', {
      branchId,
      startDate,
      endDate,
    });
  },
  getBatchFeesData: async (courseId, startDate, endDate) => {
    return api.post('/dashboard/batch-fee-overview-chart-data', {
      courseId,
      startDate,
      endDate,
    });
  },
  getPlacementDataForChart: async (branchId, startDate, endDate) => {
    return api.post('/dashboard/placement-overview', {
      branchId,
      startDate,
      endDate,
    });
  },
  getBatchPlacementData: async (courseId, startDate, endDate) => {
    console.log(courseId, 'sjhdjad');
    return api.post('/dashboard/get-batch-placement-overview', {
      courseId,
      startDate,
      endDate,
    });
  },
  getRecentAssignments: async (branchId, limit = 10, search = '') => {
    return api.post('/dashboard/recent-assignments', { branchId, limit, search });
  },
};

export default dashboardService;
